<div class="container-fluid" *ngIf="isLoggedIn">
  <div class="row">
    <div class="col-10 col-lg-8 offset-lg-2">
      <div class="content-area__white-box sensitive-data">
        <div class="content-area__white-box__heading">
          <h2 class="sensitive-data-h2">{{ "sensitiveData.sensitiveDataHeader" | translate }}</h2>
        </div>

        <div>
          <p class="sensitive-data-paragraph" [innerHTML] = '"sensitiveData.sensitiveDataP1" | translate'></p>
          <p class="sensitive-data-paragraph">{{ "sensitiveData.sensitiveDataP2" | translate }}</p>
        </div>


        <div class="custom-control custom-checkbox vertical">
          <input type="checkbox" [disabled]="isCheckboxDisabled" class="custom-control-input"
            id="do-not-sell" [ngClass]="{'newly-added-loc': highlightGroup}" [checked] = "CPRAdoNotSell">
          <label class="custom-control-label" [ngClass]="{'newly-added-loc': highlightGroup}" for="do-not-sell">
            {{ "sensitiveData.sensitiveDataDoNotSell" | translate }}</label>
        </div>
        <div class="custom-control custom-checkbox vertical">
          <input type="checkbox" [disabled]="isCheckboxDisabled" class="custom-control-input"
            id="limit" [ngClass]="{'newly-added-loc': highlightGroup}" [checked] = "CPRALimit">
          <label class="custom-control-label" [ngClass]="{'newly-added-loc': highlightGroup}" for="limit"> {{ "sensitiveData.sensitiveDataLimit" | translate }} </label>
        </div>


        <div class="sensitive-data-buttons">

          <button type="submit" name="Submit" [disabled]="isGlobalUser" [ngClass]="{'btn-primary--disabled disable': isGlobalUser}"
            class="btn btn-primary btn-primary--icon-left sensitive-data-button" (click)="saveUserDetails()">{{ "sensitiveData.sensitiveDataSubmitButton" | translate }}</button>
          <button type="cancel" name="Cancel"
            class="btn btn-reset btn-reset--icon-right sensitive-data-button" (click)="redirectHome()">{{ "sensitiveData.sensitiveDataCancelButton" | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- #87925 Save the selection success message
Changed by Laura Szmulewicz L55766
Change date: 11/18/2022 -->

<p-toast key="sensitiveDataSucess" position="center" [style]="{ marginTop : '100px', width: '400px' }" [closable]="true" [baseZIndex]="500" [autoZIndex]="100" [hideTransitionOptions]="'250ms'">
  <ng-template let-message pTemplate="message">
      <div style="text-align: center; padding: 10px 0 0 20px;">
        <p>{{"sensitiveData.messageText.changesSaved.successHeader" | translate}}</p>
          <p>{{"sensitiveData.messageText.changesSaved.sucessText" | translate}}</p>
          <p class="homeBtnCont"><button type="button" name="goToHome" (click)="redirectHome()" class="btn btn-primary btn-primary--icon-right btn-negative goToHomeBtn" style="margin-top: 10px;">
            {{"sensitiveData.messageText.changesSaved.btnText" | translate}}
              <i class="fas fa-arrow-circle-right"></i>
          </button></p>
      </div>
  </ng-template>
</p-toast>
<p-toast key="sensitiveDataError" position="center" [style]="{ marginTop : '100px', width: '400px' }" [closable]="true" [baseZIndex]="500" [autoZIndex]="100" [hideTransitionOptions]="'250ms'" [preventOpenDuplicates]="true">
  <ng-template let-message pTemplate="message">
    <div style="text-align: center; padding: 10px 0 0 20px;">
      <p>{{"sensitiveData.messageText.error.errorHeader" | translate}}</p>
        <p>{{"sensitiveData.messageText.error.errorText" | translate}}</p>
        <p class="homeBtnCont"><button type="button" name="goToHome" (click)="redirectHome()" class="btn btn-primary btn-primary--icon-right btn-negative goToHomeBtn" style="margin-top: 10px;">
          {{"sensitiveData.messageText.error.btnText" | translate}}
            <i class="fas fa-arrow-circle-right"></i>
        </button></p>
    </div>
  </ng-template>
</p-toast>